import { render, staticRenderFns } from "./tab_io_detail_ys.vue?vue&type=template&id=943c3328&scoped=true"
import script from "./tab_io_detail_ys.vue?vue&type=script&lang=js"
export * from "./tab_io_detail_ys.vue?vue&type=script&lang=js"
import style0 from "./tab_io_detail_ys.vue?vue&type=style&index=0&id=943c3328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "943c3328",
  null
  
)

export default component.exports